import debounce from './debounce';

function dispatch() {
  document.dispatchEvent(new CustomEvent('theme:resize', {
    bubbles: true,
  }));
}

function resizeListener() {
  window.addEventListener(
    'resize',
    debounce(function() {
      dispatch();
    }, 50),
  );
}

export default resizeListener;
